export const genreList = ['All Genre', 'Education', 'Sports', 'Comedy', 'Lifestyle'];
export const ageList = ['Any Age Group', '7+', '12+', '16+', '18+'];